import { get } from 'lodash'

import { AuditCampaign, ProjectLinkableItemStateResource } from '@skinsoft/types'

export const id = (campaign: AuditCampaign) => get(campaign, 'id')

export const auditors = (campaign: AuditCampaign) => get(campaign, "auditProjectSchema.authorizedAuditor")
export const auditType = (campaign: AuditCampaign) => get(campaign, "auditProjectSchema.auditType.ref") || get(campaign, "auditProjectSchema.auditType")
export const campaignManager = (campaign: AuditCampaign) => get(campaign, 'auditProjectSchema.campaignManager')
export const identificationNumber = (campaign: AuditCampaign) => get(campaign, 'projectSchema.identificationNumber.value') || get(campaign, 'projectSchema.identificationNumber')
export const title = (campaign: AuditCampaign, locale: string) => get(campaign, `projectSchema.title.translatedString.${locale}`)
export const campaignCreationDate = (campaign: AuditCampaign) => get(campaign, 'auditProjectSchema.campaignCreationDate')

export const linkableItems = (campaign: AuditCampaign): ProjectLinkableItemStateResource[] => {
    return get(campaign, 'workflowSchema.linkableItems', []) || []
}
export const auditRecords: (campaign: AuditCampaign) => string[] = (campaign: AuditCampaign) => {
    const records = get(campaign, 'auditProjectSchema.auditReports', []) as any[]
    return records.map(record => {
        if(record instanceof String || typeof record === 'string') {
            return record as string
        }

        return record.ref ?? record as string
    })
}